import { OuiSelectOption } from 'omnium-ui/form-field';

export type RegimeMatrimonialType =
  | 'COMM_MEU_ACQ'
  | 'COMM_RED_ACQ'
  | 'COMM_UNIV'
  | 'COMM_UNIV_ATTR'
  | 'PART_ACQ'
  | 'SEP_BIENS'
  | 'SEP_BIENS_ACQ'
  | 'INDIVISION';

export const typeRegimeMatrimonialMariageOptions: OuiSelectOption<RegimeMatrimonialType>[] = [
  { label: 'Communauté réduite aux acquêts', value: 'COMM_RED_ACQ' },
  { label: 'Communauté de meubles et acquêts', value: 'COMM_MEU_ACQ' },
  { label: 'Communauté universelle', value: 'COMM_UNIV' },
  { label: "Communauté universelle avec clause d'attribution intégrale", value: 'COMM_UNIV_ATTR' },
  { label: 'Participation aux acquêts', value: 'PART_ACQ' },
  { label: 'Séparation de biens', value: 'SEP_BIENS' },
  { label: "Séparation de biens avec société d'acquêts", value: 'SEP_BIENS_ACQ' },
];

export const typeRegimeMatrimonialPacsOptions: OuiSelectOption<RegimeMatrimonialType>[] = [
  { label: 'Séparation de biens', value: 'SEP_BIENS' },
  { label: 'Indivision', value: 'INDIVISION' },
];
